export interface Coordinates {
  latitude: string;
  longitude: string;
}

export interface AddressJSON {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  coordinates?: {
    latitude: string;
    longitude: string;
  }
}
export default class Address {
  address1: string;
  address2?: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  coordinates?: Coordinates;

  constructor(
    address1: string,
    address2: string | undefined,
    city: string,
    state: string,
    postalCode: string,
    country: string,
    coordinates?: Coordinates
  ) {
    this.address1 = address1;
    this.address2 = address2;
    this.city = city;
    this.state = state;
    this.postalCode = postalCode;
    this.country = country;
    this.coordinates = coordinates;

    Address.validate(
      this.address1,
      this.address2,
      this.city,
      this.state,
      this.postalCode,
      this.country,
      this.coordinates
    );
  }

  static validate(
    address1: string,
    address2: string | undefined,
    city: string,
    state: string,
    postalCode: string,
    country: string,
    coordinates?: Coordinates
  ) {
    if (!address1 && !city && !state && !postalCode && !country && !coordinates) {
      throw new InvalidAddressError("at least one of the fields must be non-empty.");
    }
  }

  public static fromJSON(json: AddressJSON): Address {
    const { address1, address2, city, state, postalCode, country, coordinates } = json;
    return new Address(
      address1,
      address2,
      city,
      state,
      postalCode,
      country,
      coordinates
    );
  }

  public toJSON(): AddressJSON {
    return {
      address1: this.address1,
      address2: this.address2,
      city: this.city,
      state: this.state,
      postalCode: this.postalCode,
      country: this.country,
      coordinates: this.coordinates
    };
  }

  public isEqualTo(other?: Address): boolean {
    if (!other) return false;
    return this.address1 === other.address1
      && this.address2 === other.address2
      && this.city === other.city
      && this.state === other.state
      && this.postalCode === other.postalCode
      && this.country === other.country
      && this.coordinates === other.coordinates;
  }

  public toString(): string {
    const parts = [
      this.address1,
      this.address2,
      this.city,
      this.state,
      this.postalCode,
      this.country
    ].filter(Boolean);
    return parts.join(', ');
  }
}

export class InvalidAddressError extends Error {
  constructor(value: string) {
    super(`Invalid address: ${value}`);
  }
}
